import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { PveCampEntry } from "../types/pve";
import { castleKeys } from "./castle";
import { marchKeys } from "./marches";

export const pveKeys = {
  camps: ["pve-camps"] as const,
};

export function usePveCamps(enabled: boolean) {
  return useQuery({
    queryKey: pveKeys.camps,
    queryFn: async () => {
      const res = await api.get<PveCampEntry[]>("/pve-camps");
      return res.data;
    },
    enabled,
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}

export function usePveAttack() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      campId,
      units,
      heroIds,
      stratagem,
    }: {
      campId: string;
      units: Record<string, number>;
      heroIds: string[];
      stratagem?: number;
    }) => {
      const res = await api.post(`/pve-attack/${campId}`, {
        units,
        heroIds,
        stratagem: stratagem ?? 0,
      });
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: castleKeys.state });
      qc.invalidateQueries({ queryKey: marchKeys.active });
      qc.invalidateQueries({ queryKey: pveKeys.camps });
    },
  });
}
